export const lectriumUrlsPatterns = ['lectrium', 'localhost']
